import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'antd';
import { connect } from 'react-redux';

import InfoCard from '../InfoCard';

import { composePlanCommonInfo } from '../../utils/plan';

import { FIELDS } from './config';

const propTypes = {
  packageName: PropTypes.string.isRequired,
  numServices: PropTypes.number.isRequired,
  paymentCustomerPrice: PropTypes.number.isRequired,
  paymentMonthly: PropTypes.number.isRequired,
  paymentMonths: PropTypes.number.isRequired,
  paymentPlanDiff: PropTypes.number.isRequired,
  paymentSum: PropTypes.number.isRequired,
  paymentSumPerMonth: PropTypes.number.isRequired,
  payed: PropTypes.bool,
  signed: PropTypes.bool,
  active: PropTypes.bool,
};
const defaultProps = {
  payed: false,
  signed: false,
  active: false,
};

const CommonInfo = ({ ...props }) => (
  <Row gutter={16}>
    <Col span={12}>
      <InfoCard data={props} fields={FIELDS} />
    </Col>
  </Row>
);

CommonInfo.propTypes = propTypes;
CommonInfo.defaultProps = defaultProps;

const mapStateToProps = ({ admin: { planDetails } }) =>
  composePlanCommonInfo(planDetails);

export default connect(mapStateToProps)(CommonInfo);
